import { render, staticRenderFns } from "./crime.vue?vue&type=template&id=48647f1b&scoped=true&"
import script from "./crime.vue?vue&type=script&lang=js&"
export * from "./crime.vue?vue&type=script&lang=js&"
import style0 from "./crime.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crime.vue?vue&type=style&index=1&id=48647f1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48647f1b",
  null
  
)

export default component.exports